'use strict';

var angular = require('angular');
var _ = require('lodash');
var CreateRulePopoverDirective = function CreateRulePopoverDirective(strategyConstants) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/create-rule-popover.html'),
    link: function link($scope) {
      $scope.ruleType = strategyConstants.RuleType.QUICK;
      $scope.ruleTypes = _.clone(strategyConstants.RuleType);
      $scope.createRule = function () {
        $scope.$emit('rule:createRule', $scope.ruleType);
      };
      $scope.dropDownClicked = function (e) {
        e.stopPropagation();
        if (angular.element(e.target).hasClass('cancel-drop-down')) {
          angular.element('.toolbar-dropdown-menu').parent().removeClass('open');
        }
      };
    }
  };
};
CreateRulePopoverDirective.$inject = ['StrategyConstants'];
module.exports = CreateRulePopoverDirective;